import ENTITY_DATA from "../../../../data/index.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { id, form, submitBtn } = data;
        const fileURL = APP_COMPONENTS.fileForms.getURL(id);
        if (!fileURL) {
            APP_COMPONENTS.fileError.show('INCOMPLETE', 'Please upload an image before submitting.');
            return;
        }
        const payload = {
            type: form.eventtype.value.trim(),
            desc: form.description.value.trim(),
            image: fileURL,
            video: form.videolink.value.trim() || null,
            orderIndex: ENTITY_DATA.getAll().length,
            ensemble: {
                2: {
                    price: Number(form.two.value.trim()),
                    video: form.videotwo.value.trim() || null
                },
                3: {
                    price: Number(form.three.value.trim()),
                    video: form.videothree.value.trim() || null
                },
                4: {
                    price: Number(form.four.value.trim()),
                    video: form.videofour.value.trim() || null
                },
                5: {
                    price: Number(form.five.value.trim()),
                    video: form.videofive.value.trim() || null
                },
                6: {
                    price: Number(form.six.value.trim()),
                    video: form.videosix.value.trim() || null
                },
                7: {
                    price: Number(form.seven.value.trim()),
                    video: form.videoseven.value.trim() || null
                }
            }
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/events/create', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Event added successfully.`
            });
            APP_COMPONENTS.eventForms.update(id, response.id);
            APP_COMPONENTS.fileForms.update(id, form, response.id);
            ENTITY_DATA.add({ id: response.id, title: response.title });
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
